import React from 'react';

import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import {ModalSchoolModes} from "root/Modals/ModalSchool/ModalSchool";
import DropdownSchoolGroups from "root/ReactHookForm/ui/DropdownSchoolGroups";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents/SmartErrorDiv";
import DropdownSchoolTypes from "root/ReactHookForm/ui/DropdownSchoolTypes";
import BootstrapRow from "ui/BootstrapRow";

const FormFragmentSchoolDetails = ({control, register, formErrors, formError, sectionName, readOnly, mode}) =>
{
    const schoolIdReadOnly = mode !== ModalSchoolModes.CREATE ;

    const validateSchoolType = (val) =>
    {
        if (val === null)
        {
            return "Please Select a type.";
        }
    }

    const validateSchoolGroup = (val) =>
    {
    }

    return (
        <>
            <BootstrapRow>
                <div className='col-md-12'>
                    <label>School ID</label>
                    <input readOnly={schoolIdReadOnly} className='form-control' {...register("school.school_id", {required: true, maxLength: 7})} />
                    {formErrors.school?.school_id?.type === 'required' && <ErrorDiv>Please enter a school ID less than 7 characters</ErrorDiv>}
                    {formError !== null && <ErrorDiv>A School already exists with this School ID</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-12'>
                    <label>Partnership</label>
                    <DropdownSchoolGroups name='school.school_group_id' authority_id={1} control={control} rules={{validate: validateSchoolGroup}}
                                          placeHolder='Please Select a school group' includeNone={true} readOnly={false}/>
                    {formErrors.school?.school_group_id && <ErrorDiv>{formErrors.school.school_group_id.message}</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-12'>
                    <label>Provider Type</label>
                    <DropdownSchoolTypes name='school.school_type_id' control={control} rules={{validate: validateSchoolType}}
                                         placeHolder='Please Select a school type' readOnly={false} isSearchable={true}/>
                    {formErrors.school?.school_type_id && <ErrorDiv>{formErrors.school.school_type_id.message}</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-12'>
                    <label>School Name</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.school_name", {required: true, maxLength: 100})} />
                    {formErrors.school?.school_name?.type === 'required' && <ErrorDiv>Please enter a school name</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-6'>
                    <label>Address Line 1</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.address1", {required: true, maxLength: 100})} />
                    {formErrors.school?.address1?.type === 'required' && <ErrorDiv>Please enter an address</ErrorDiv>}
                </div>

                <div className='col-md-6'>
                    <label>Address line 2</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.address2", {required: false, maxLength: 100})} />
                    {formErrors.school?.address2?.type === 'required' && <ErrorDiv>Please enter a school name</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-6'>
                    <label>Address Line 3</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.address3", {required: false, maxLength: 100})} />
                    {formErrors.school?.address3?.type === 'required' && <ErrorDiv>Please enter a school name</ErrorDiv>}
                </div>

                <div className='col-md-6'>
                    <label>Address line 4</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.address4", {required: false, maxLength: 100})} />
                    {formErrors.school?.address4?.type === 'required' && <ErrorDiv>Please enter a school name</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-6'>
                    <label>Postcode</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.postcode", {
                        required: true, maxLength: 8, pattern: {
                            value: /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i,
                            message: "Invalid Postcode"
                        }
                    })} />
                    <SmartErrorDiv sectionName='school' name='postcode' maxLength={10} formErrors={formErrors}/>
                </div>

                <div className='col-md-6'>
                    <label>Telephone</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.phone", {required: false, maxLength: 100})} />
                    {formErrors.school?.phone?.type === 'required' && <ErrorDiv>Please enter a telephone number</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-12'>
                    <label>Email Address</label>
                    <input readOnly={readOnly} className='form-control' {...register("school.email", {required: false, maxLength: 100})} />
                    {formErrors.school?.email?.type === 'required' && <ErrorDiv>Please enter an email address</ErrorDiv>}
                </div>
            </BootstrapRow>
        </>

    )
}

export default FormFragmentSchoolDetails;